import controller from './payment-bills.controller';
import template from './payment-bills.view.html';

let PaymentBillsComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default PaymentBillsComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payment-bills/payment-bills.component.js
 **/